import React from "react";
import "./../Homepage.css";
import "./weekly.css";

import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';

import footprintOriginal from "./../photos/electronic-prod/footprint-original.webp";
import footprintLed from "./../photos/electronic-prod/footprint-led.webp";
import schLed from "./../photos/electronic-prod/sch-led.webp";
import footprintNewSwitch from "./../photos/electronic-prod/footprint-newswitch.webp";
import schNewSwitch from "./../photos/electronic-prod/sch-newswitch.webp";
import footprintNewBoard from "./../photos/electronic-prod/footprint-newboard.webp";
import schNewBoard from "./../photos/electronic-prod/sch-newboard.webp";

import footprint from "./../photos/electronic-prod/footprint.webp";
import milling from "./../photos/electronic-prod/milling.webp";
import traceBoard from "./../photos/electronic-prod/trace-board.webp";

import espsolder from "./../photos/electronic-prod/esp-solder.webp";
import fullsolder from "./../photos/electronic-prod/full-solder.webp";

import pinMap from "./../photos/electronic-prod/pin_map.webp";
import strappingPins from "./../photos/electronic-prod/strapping-pins.webp";
import ledOff from "./../photos/electronic-prod/led-off.webp";
import ledOn from "./../photos/electronic-prod/led-on.webp";

import sketch from "./../photos/electronic-prod/wifi_sketch_pcb.ino";

import demo from "./../photos/electronic-prod/demo.mp4";

const slide1 = [[{image: footprintOriginal, caption: "Original Footprint"}],
                [{image: schLed, caption: "Schematic with new LED"},{image: footprintLed, caption: "Footprint with new LED"}],
                [{image: schNewSwitch, caption: "Schematic with updated switches"}, {image: footprintNewSwitch, caption: "Footprint with updated switches"}],
                [{image: schNewBoard, caption: "Schematic with updated ESP32"}, {image: footprintNewBoard, caption: "Footprint with updated ESP32"}]
            ];

const Week6 = (props) => {
    return (
      <div className="HP-module">
        <div className="HP-subtitle">Week 6</div>
        <div className="HP-body">
            In this week of HTM(A)A, we built on our electronic design from last week and moved on to electronic production, or building PCBs. Making PCBs was 
            one of the first parts of the class that caught my eye, so I was really looking forward to getting to learn how it was done. Before I could print 
            my circuit board from <span onClick={() => props.changePage('week5')} className="weekly-pageLink">Week 5</span>, however, I had to make some edits. 
            First, I wanted to add to my board a second, user configurable, LED so that I could use my program from 
            <span onClick={() => props.changePage('week3')} className="weekly-pageLink">Week 3</span> and have an LED track whether or not my startup site was live. 
            Once I added the new LED, I realized that the parts I used for the footprints were not part of the KiCad Fab library for the class, rather just 
            the default KiCad libraries, and would not be guaranteed to be in stock for my PCB. To fix this, I went through all of the LED, resistor, switch, and 
            button components and reconfigured them for the Fab class footprints. I then realized that my esp32C3 XIAO board footprint was also made for a 
            through hole component, not the surfce mount part I was using, so I changed that footprint and cleaned up my traces so that I was finally ready to 
            mill my board.
        </div>
        <Slide>
          {slide1.map((images, i) => (<div className="HP-slideDiv" key={i}>
            {images.map((image) => <div className="HP-photoObject" key={image.caption}>
                <img src={image.image} className="HP-slidePhotoSmall"/>
                <div className="HP-caption">{image.caption}</div>
              </div>)}
            </div>)
          )}
        </Slide>
        <div className="HP-spacer" />
        <div className="HP-flexCenter">
            <div className="HP-half HP-body">
                With the board design now finished, I exported the gerber file to print on the mill (SVG <a download href={footprint}>here</a>). The milling 
                process was surprisingly short, but unfortunaltely the tools I used were rather dull, which you will later see was a problem.
            </div>
            <div className="HP-photoContent HP-half">
                <div className="HP-photoObject">
                    <img src={milling} className="HP-smallPhoto" style={{marginTop:"20px"}}/>
                    <div className="HP-caption">Milling the PCB</div>
                </div>
                <div className="HP-photoObject">
                    <img src={traceBoard} className="HP-smallPhoto"/>
                    <div className="HP-caption">Complete milling of the board</div>
                </div>
            </div>
        </div>
        <div className="HP-spacer" />
        <div className="HP-body">
            With the milling of the board done, the traces were a little fuzzy on the edges so I did my best with low grit sandpaper and 
            tweezers to clean up the traces so that the paths were not shorted to one another and were connected properly. Once this was done, I moved on to soldering. 
            To solder the board I tried both traditional iron soldering and paste/hot air soldering. With some advice I found that for the larger components (ESP32), 
            iron soldering was much easier as once one pad was set I could quickly do the rest and the board would not move. For the small 1206mm components (resistors and LEDs), 
            paste and hot air soldering was much easier, as placing these small components was quite difficult especially with the coffee I had beforehand (I would not reccomend). 
            For the switches and buttons I used a combination of both methods, but generally paste and hot air was again easier for these components.
        </div>
        <div className="HP-photoContainer" style={{alignItems:"center", justifyContent:"space-evenly"}}>
            <div className="HP-photoObject">
                <img src={espsolder} className="HP-medPhoto"/>
                <div className="HP-caption">PCB with ESP32 soldered with iron</div>
            </div>
            <div className="HP-photoObject">
                <img src={fullsolder} className="HP-medPhoto"/>
                <div className="HP-caption">PCB with all components soldered, mix of hot air and iron</div>
            </div>
        </div>
        <div className="HP-spacer" />
        <div className="HP-body">
            Now that I had the board soldered and ready to go, I began to run into the infamous bugs with circuit design. I checked all of my pins and traces carefully for 
            continuity and made sure there were no unwanted shorts between pins of the ESP32. Once satisfied, I plugged in the microcontroller and burned the bootloader along 
            with the echo script from week 3 and was relieved to see the ESP32 responded to me as expected. One issue, however, was that the LEDs were extremely dim. Another issue 
            was that, upon further testing with digital inputs, the input to GPIO pin 9, the pin connected to the left switch that connected to the button when in the 'up' configuration, 
            was always reading a digital 1 regardless of the button state. From the schematic you can see that the button connects the pin to 3.3v, so that it should read high when pressed, 
            but was also pulled low so that it should read 0v when not pressed, or low. As it turns out, both of these issues were caused by the same mistake. Looking at the photo above closely  
            you can see that the resistors connected to the LEDs and the button were '1004', or 1MOhm resistors, not the 1KOhm intended. Once I realized this mistake I removed the resistors 
            using the solder remove tool (very useful!) and replaced the components with the correct 1KOhm resistors. 
        </div>
        <div className="HP-spacer" />
        <div className="HP-body">
            With the hardware finally correct, I plugged my board back in and found that I was unable to communicate with it in any way. Regardless of any bootload, program, or other reset method 
            I tried the board would not respond to my programs. On the plus side, however, the power LED was now nice and bright. After lots of connectivity testing and head scratching, Anthony and I found the issue. 
            The ESP32C3, hidden in the datasheet, has a few special pins designated as 'strapping pins', pins that when put in a certain state on reset put the board into different operating modes. 
            When no components are connected, the pins will automatically be configured for downloading and running programs, but you can manually adjust the pins for certain behaviors. 
        </div>
        <div className="HP-flex">
            <div className="HP-photoContent HP-half">
                <div className="HP-photoObject">
                    <img src={pinMap} className="HP-medPhoto" style={{marginTop:"20px"}}/>
                    <div className="HP-caption">ESP32C3 XIAO pinout</div>
                </div>
                <div className="HP-photoObject">
                    <img src={strappingPins} className="HP-medPhoto"/>
                    <div className="HP-caption">Strapping pin configuration</div>
                </div>
            </div>
            <div className="HP-body HP-half">
                Looking through the datasheet, the three strapping pins were GPIO 2, GPIO 8, and GPIO 9 (of course 2 of the 3 pins I assigned special functionality to). GPIO 2 needs to be a digital 1 on reset, 
                GPIO 9 needs to be a 0, and GPIO 8 nees to be a 1 as well. I was not using GPIO 8, but the other two were actively being pulled by my circuit. I didn't have any issues the first time 
                around likely due to my exceptionally large resistors being overcome in functionality by the chip internals. I then removed the resistor from GPIO 2, disconnecting the LED from the 
                circuit and letting the pin float to it's default, as well as configuring the switch on GPIO 9 to float the pin. This still didn't work however. With more help from Anthony we found 
                that the traces made by the dull mill tool actually left some residue that I didn't catch in my cleaning process, and the GPIO 9 was being shorted to a different trace, preventing the 
                strapping pins from being in the correct configuration. After a bit more board cleanup, we tried again and the board finally worked again. 
            </div>
        </div>
        <div className="HP-spacer" />
        <div className="HP-body">
            With the board finally working, I made some small edits to my site pinging code from week 3, changing it so that the LED on GPIO 2 turned on with a successful ping (the 
            resistor actually wasn't affecting the strapping pin functionality, and was put back in place to allow the LED to function). I also configured the code so that a button press 
            with the left switch in the up configuration would trigger an instant site ping. Now I could press a button to ping my site, or let it run on it's own, and see the resut visually on 
            my board! My board also has several pins on it, allowing for external connections which can also trigger a site refresh with the left switch in the down configuration. The code can 
            be found <a download href={sketch}>here</a>. My main takeaways from this debugging: use a sharp mill and read your datasheets!
        </div>
        <div className="HP-photoContainer" style={{alignItems:"center", justifyContent:"space-evenly"}}>
            <div className="HP-photoObject">
                <img src={ledOn} className="HP-medPhoto"/>
                <div className="HP-caption">Final PCB with site pinged successfully</div>
            </div>
            <div className="HP-photoObject">
                <img src={ledOff} className="HP-medPhoto"/>
                <div className="HP-caption">Final PCB with site ping failure</div>
            </div>
        </div>
        <div className="HP-spacer" />
        <video src={demo} preload="auto" controls className="HP-video"/>
      </div>
    )
}

export default Week6;